export const translationsObject = {
    en: {
        languageName: 'English',
    },
    no: {
        languageName: 'Norsk',
    },
    da: {
        languageName: 'Dansk',
    },
    sv: {
        languageName: 'Svensk',
    },
};
